module.exports = __webpack_public_path__ + "static/What-Causes-a-Spinal-Subluxation-0abbc9c9a97e4db7bc313d21d8d0cdcd.webp";